export const formatNumber = (value, options = {}) => {
  value = Number(value) || 0;
  //fix -0 issue
  if (options.style === "percent") {
    if (value > -0.00005 && value <= 0) value = 0;
  } else {
    if (value > -0.005 && value <= 0) value = 0;
  }
  return new Intl.NumberFormat("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...options
  }).format(value);
};
